import { Fragment, useMemo } from 'react'
import { i18n as I18n } from 'builder/utils/i18n'
import Tooltip from 'builder/components/Tooltip/Tooltip'
import { PrefillPopover } from 'builder/components/PrefillPopover'
import { SyncLocallyIcon, SyncRemoteIcon, SyncStatusContainer } from './styles'

interface Props {
  updatedAt: string
  documentId: number
  isOnline: boolean
  isSyncing: boolean
  isPrefilling?: boolean
}

export const SyncStatus = (props: Props) => {
  const { updatedAt, documentId, isOnline, isPrefilling = false, isSyncing } = props

  const text = useMemo(() => {
    if (!isOnline && isSyncing) return I18n.t('builder.resume_editor.saving_locally')
    if (!isOnline) return I18n.t('builder.resume_editor.offline')
    if (isPrefilling) return I18n.t('builder.resume_editor.prefilling')
    if (isSyncing) return I18n.t('builder.resume_editor.saving')

    return I18n.t('builder.resume_editor.saved')
  }, [isOnline, isSyncing, isPrefilling])

  return (
    <Fragment>
      {isOnline ? (
        <SyncStatusContainer>
          <SyncRemoteIcon isSyncing={isSyncing || isPrefilling} />
          {text}
          <PrefillPopover documentId={documentId} />
        </SyncStatusContainer>
      ) : (
        <Tooltip
          value={I18n.t('builder.resume_editor.every_change_is_saved', { updatedAt })}
          position="bottom"
          multiline
        >
          <SyncStatusContainer>
            <SyncLocallyIcon isSyncing={isSyncing} />
            {text}
          </SyncStatusContainer>
        </Tooltip>
      )}
    </Fragment>
  )
}
